/** Channel-mapping service (T040/T041, US4). Wraps upsertSourceLink for the `channel` kind. */
import { callable } from './firebase';
import type { CallableResult, ChannelArea, SourceLink } from '../types/entities';

export interface UpsertChannelInput {
  project_id: string;
  external_id: string; // the channel id
  channel_name: string; // parsed for the convention suggestion
  area: ChannelArea | null;
  has_client: boolean;
}

export const upsertChannel = callable<
  UpsertChannelInput & { kind: 'channel' },
  CallableResult<SourceLink>
>('upsertSourceLink');

/** UI-only hint: pre-select the area if the channel name's last segment is a known area. */
const AREAS: ChannelArea[] = ['sales', 'ops', 'pm'];
export function guessArea(channelName: string): ChannelArea | null {
  const segments = channelName.trim().replace(/^#/, '').toLowerCase().split('-').filter(Boolean);
  const last = segments[segments.length - 1] as ChannelArea | undefined;
  return segments.length >= 2 && last && AREAS.includes(last) ? last : null;
}
